import "./App.scss";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import Navigation from "./components/Navigation/Navigation/Navigation";
import Home from "./components/HomePage/Home/Home";
import Footer from "./components/Footer/Footer";
import CompanyEvents from "./components/Gallery/CompanyEvents/CompanyEvents";
import EventsDataDetails from "./components/Gallery/CompanyEvents/EventsDataDetails/EventsDataDetails";
import CompanyNews from "./components/Gallery/CompanyNews/CompanyNews";
import UnsettledClaims from "./components/Reports/UnsettledClaims/UnsettledClaims";
import Branch from "./components/About/Branch/Branch";
import ContactUs from "./components/ContactUs/ContactUs";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CompanyInfo from "./components/About/CompanyInfo/CompanyInfo";
import CompositionBoard from "./components/About/CompositionBoard/CompositionBoard";
import VisionMission from "./components/About/VisionMission/VisionMission";
import Background from "./components/About/Background/Background";
import Objective from "./components/About/Objective/Objective";
import CodeConduct from "./components/About/CodeConduct/CodeConduct";
import CoreValues from "./components/About/CoreValues/CoreValues";
import CapitalStructure from "./components/About/CapitalStructure/CapitalStructure";
import PropertyInsurance from "./components/Services/PropertyInsurance/PropertyInsurance";
import MiscellaneousInsurance from "./components/Services/MiscellaneousInsurance/MiscellaneousInsurance";
import MotorInsurance from "./components/Services/MotorInsurance/MotorInsurance";
import MarineInsurance from "./components/Services/MarineInsurance/MarineInsurance";
import EngineeringInsurance from "./components/Services/EngineeringInsurance/EngineeringInsurance";
import CompanyPhotos from "./components/Gallery/CompanyPhotos/CompanyPhotos";
import CompanyVideos from "./components/Gallery/CompanyVideos/CompanyVideos";
import CreditRating from "./components/Reports/CreditRating/CreditRating";
import Award from "./components/About/Award/Award";
import ChairmanReport from "./components/Reports/ChairmanReport/ChairmanReport";
import BalanceSheet from "./components/Reports/BalanceSheet/BalanceSheet";
import ProfitLossAccount from "./components/Reports/ProfitLossAccount/ProfitLossAccount";
import SponsorDirector from "./components/About/SponsorDirector/SponsorDirector";
import UnderConstruction from "./components/UnderConstruction/UnderConstruction";
import AllReports from "./components/Reports/AllReports/AllReports";
import DirectorReport from "./components/Reports/DirectorReport/DirectorReport";
import AuditorsReport from "./components/Reports/AuditorsReport/AuditorsReport";
import CashFlow from "./components/Reports/CashFlow/CashFlow";
import FormAa from "./components/Reports/FormAa/FormAa";
import StatusOfCompliance from "./components/Reports/StatusOfCompliance/StatusOfCompliance";
import CeoReport from "./components/Reports/CeoReport/CeoReport";
import CompanyPhotoStatic from "./components/Gallery/CompanyPhotos/CompanyPhotoStatic";
import ScrollToTop from "./components/ScrollToTop";
import NoticeBoard from "./components/Reports/NoticeBoard/NoticeBoard";
import DividendDistribution from "./components/ShareHolderInfo/DividendDistribution/DividendDistribution";
import DetailsOfShareholding from "./components/About/DetailsOfShareholding/DetailsOfShareholding";
import UnclaimDividend from "./components/ShareHolderInfo/UnclaimDividend/UnclaimDividend";
import DividendCompliance from "./components/ShareHolderInfo/DividendCompliance/DividendCompliance";
import ShareholderInvestorNotice from "./components/ShareHolderInfo/ShareholderInvestorNotice/ShareholderInvestorNotice";
import Modal from "./components/Modal/Modal";
import Career from "./components/Career/Career";

function App() {
  // const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  // const url = `${rupali_api_url}/API/webApi/CompanyInfo`;
  // console.log("Rupali Api Url", rupali_api_url, url);

  return (
    <div className="container-fluid p-0">
      <ScrollToTop />

      {/* <Modal /> */}

      <div className="homepage">
        <Navigation />

        <Routes>
          {/* Home page & Home*/}
          <Route path="/" element={<Home />} />

          {/* !Home page & Home*/}

          {/* About */}
          <Route path="about" />
          <Route
            path="/vision-mission"
            element={<VisionMission></VisionMission>}
          />
          <Route path="/background" element={<Background></Background>} />
          <Route path="branch-info" element={<Branch></Branch>} />
          <Route path="/company-information" element={<CompanyInfo />} />
          <Route path="/composition-board" element={<CompositionBoard />} />
          <Route
            path="/details-of-shareholding"
            element={<DetailsOfShareholding />}
          />
          {/* <Route path="/sponsor-director" element={<SponsorDirector />} /> */}
          <Route path="/code-conduct" element={<CodeConduct />} />
          <Route path="/core-values" element={<CoreValues />} />
          <Route path="/company-structure" element={<CapitalStructure />} />
          <Route path="/award" element={<Award />} />
          <Route path="/objective" element={<Objective />} />
          {/* !About */}

          {/* Business And Services */}
          <Route path="/fire-insurance" element={<PropertyInsurance />} />
          <Route path="/motor-insurance" element={<MotorInsurance />} />
          <Route path="/marine-insurance" element={<MarineInsurance />} />
          <Route
            path="/engineering-insurance"
            element={<EngineeringInsurance />}
          />
          <Route
            path="/miscellaneous-insurance"
            element={<MiscellaneousInsurance />}
          />
          {/* !Business And Services */}

          {/* Reports & Financial Statement */}
          <Route path="/chairman-report" element={<ChairmanReport />} />
          <Route path="/managingDirector-report" element={<CeoReport />} />
          <Route path="/director-report" element={<DirectorReport />} />
          <Route path="/Auditor-report" element={<AuditorsReport />} />
          <Route path="/UnsettledClaims" element={<UnsettledClaims />} />
          <Route path="/balance-sheet" element={<BalanceSheet />} />
          <Route path="/profit-loss-account" element={<ProfitLossAccount />} />
          <Route path="/credit-rating" element={<CreditRating />} />
          <Route path="/cash-flow-statement" element={<CashFlow />} />
          <Route path="/all-reports" element={<AllReports />} />
          <Route path="/from-aa" element={<FormAa />} />
          <Route path="/CorpGovernance" element={<StatusOfCompliance />} />
          <Route path="/notice-board" element={<NoticeBoard />} />

          {/* !Reports & Financial Statement */}

          {/* Gallery */}
          {/* <Route path="/company-photos" element={<CompanyPhotos />} /> */}
          <Route path="/company-photos" element={<CompanyPhotoStatic />} />
          <Route path="/company-videos" element={<CompanyVideos />} />
          <Route path="/gallery/event-photos" element={<UnderConstruction />} />
          {/* <Route path="/gallery/event-photos" element={<CompanyEvents />} /> */}
          <Route
            path="/gallery/event-photos/:eventId"
            element={<EventsDataDetails />}
          />
          <Route path="/gallery/news" element={<CompanyNews />} />
          {/* !Gallery */}

          {/* Share Holder Info */}
          <Route
            path="/shareholder-info/unclaim-stock/cash-dividend"
            element={<UnclaimDividend />}
          />
          <Route
            path="/shareholder-info/dividend-distribution-policy"
            element={<DividendDistribution />}
          />
          <Route
            path="/shareholder-info/dividend-distribution-compliance"
            element={<DividendCompliance />}
          />
          <Route
            path="/shareholder-info/Shareholders-Investors-notice"
            element={<ShareholderInvestorNotice />}
          />
          {/* !Share Holder Info */}

          {/* Bancassurance */}
          <Route
            path="/bancassurance/about-bancassurance"
            element={<UnderConstruction />}
          />
          <Route
            path="/bancassurance/bank-login"
            element={<UnderConstruction />}
          />
          <Route
            path="/bancassurance/product-list"
            element={<UnderConstruction />}
          />
          <Route
            path="/bancassurance/sell-insurance"
            element={<UnderConstruction />}
          />
          <Route
            path="/bancassurance/sell-history"
            element={<UnderConstruction />}
          />
          {/* !Bancassurance */}

          <Route path="/career" element={<Career />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/*" element={<Navigate to="/" />} />
        </Routes>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default App;
